import * as TokenHelpers from './tokenHelpers';

export function isLoggedIn() {
  let token = TokenHelpers.retrieve();
  return !!token;
}

export function getAccessToken() {

  return TokenHelpers.retrieve();
}

export function getInfo() {
  return TokenHelpers.decode();
}



// WEBPACK FOOTER //
// ./src/utils/userHelpers.js